import { useState, type FormEvent } from 'react'
import { ApiError } from '@greencandle/api-client'
import { useAuth } from '../auth'

export function Login() {
  const { signIn } = useAuth()
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState<string | null>(null)
  const [busy, setBusy] = useState(false)

  async function onSubmit(event: FormEvent) {
    event.preventDefault()
    setBusy(true)
    setError(null)
    try {
      // Deliberately no navigation here. `loginRoute`'s own `beforeLoad` (routes.tsx) sends a
      // signed-in visitor away from `/login` once `router.invalidate()` runs against the
      // updated auth context - see that file for why doing it from here instead raced the
      // context update and bounced straight back to this form.
      await signIn(username, password)
    } catch (caught) {
      // The backend answers an unknown user and a wrong password identically, on purpose
      // (FR-A1). Showing its message rather than inventing one keeps that property intact.
      setError(
        caught instanceof ApiError
          ? (caught.problem.detail ?? caught.message)
          : 'Could not reach the server.',
      )
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="centered">
      <form className="card login-card" onSubmit={onSubmit}>
        <div className="brand" style={{ marginBottom: 20 }}>
          <span className="brand-mark" aria-hidden="true" />
          Green Candle
        </div>

        <div className="field">
          <label htmlFor="username">Username</label>
          <input
            id="username"
            name="username"
            autoComplete="username"
            autoFocus
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />
        </div>

        <div className="field">
          <label htmlFor="password">Password</label>
          <input
            id="password"
            name="password"
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>

        {error && (
          <div className="notice error" style={{ marginBottom: 14 }} role="alert">
            {error}
          </div>
        )}

        <button className="primary" type="submit" disabled={busy} style={{ width: '100%' }}>
          {busy ? 'Signing in…' : 'Sign in'}
        </button>
      </form>
    </div>
  )
}
